// Port of webapp/src/components/rootPortal.tsx — dialogs and menus that must
// escape the board's scroll container render into #root-portal.

import {ReactElement, ReactNode, useEffect, useState} from 'react'
import {createPortal} from 'react-dom'

// The host node is created here but attached in the effect below; callers that
// need focus must defer it one task (see searchDialog) so it lands after attach.
function createHost(): HTMLDivElement {
    return document.createElement('div')
}

export default function RootPortal({children}: {children: ReactNode}): ReactElement | null {
    const [container] = useState<HTMLDivElement>(createHost)

    useEffect(() => {
        const host = document.getElementById('root-portal') || document.body
        host.appendChild(container)
        return () => container.remove()
    }, [container])

    return createPortal(children, container)
}
